<div mat-dialog-title class="dialogHeader">
  <h3 class="dialog-header-text">{{ 'users.policyGroups.selectLayers' | t }}</h3>
  <div class="searchWrapper">
    <sn-searchbar
      (valueChange)="onSearchValueChange($event)"
      (search)="onSearchValueChange($event)"
      [placeholder]="'common.searchByName' | t"
      [clearOnNavEnd]="false"
    ></sn-searchbar>
  </div>
</div>
<mat-dialog-content>
  <sn-data-list #list [fetchFn]="loadData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="empty"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="saveLayers()">{{ 'users.policyGroups.addLayers' | t }}</button>
</mat-dialog-actions>

<ng-template #table>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let layer">
        {{ layer.name }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="selection.toggle(layer)" *matRowDef="let layer; columns: columns"> </mat-row>
  </mat-table>
  
</ng-template>

<ng-template #empty>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>


